<template>
  <div class="list_130">
    <div class="container">
      <div class="row">
          <div class="col s12">
            <h5>検索</h5>
          </div>
          <div class="input-field col s6">
            <input type="text" v-model="keyword_space" class="validate">
            <label for="space">サークルスペース</label>
          </div>
          <div class="input-field col s6">
            <input type="text" v-model="keyword_circle" class="validate">
            <label for="circle">サークル名</label>
          </div>
        </div>
      <div class="col s12">
        <h5>サークルリスト</h5>
      </div>
        <virtual-list :size="50" :remain="30" pagemode>
          <div class="row" >
            <div class="col s3 offset-s2">スペース</div><div class="col s6">サークル名</div>
          </div>
          <div  class="row" v-for="list in filteredCircles" v-bind:key="list.space">
            <div class="col s3 offset-s2">{{list.space}}</div><div class="col s6">{{list.circle}}</div>
          </div>
        </virtual-list>
    </div>
  </div>
</template>

<script>
import virtualList from 'vue-virtual-scroll-list'

export default {
  title: 'COMITIA 130',
  name: 'list_comitia_130',
  data() {
    return {
      lists: null,
      keys: null,
      keyword_space: '',
      keyword_circle: ''
    }
  },
  created() {
    var that = this;
    this.$axios.get('/data/comitia/130.json').then(function (response) {
      that.lists = response.data;
      that.keys = Object.keys(that.lists[0]);
    });
  },
  computed: {
    filteredCircles: function() {
      const {keyword_space, keyword_circle, lists} = this
      if (!keyword_circle && !keyword_space) return lists
      return lists.filter(list => String(list.circle).toLowerCase().includes(keyword_circle.toLowerCase()) && String(list.space).includes(keyword_space) )
    }
  },
  components: { 'virtual-list': virtualList }
}
</script>

<style>
</style>
